export enum GameStatus {
	Playing = 'playing',
	Won = 'won',
	Completed = 'completed',
	GameOver = 'gameOver',
}

export interface Position {
	x: number;
	y: number;
}

export interface LetterQ {
	position: Position;
	letter: string;
	collected: boolean;
	colorSeed: number;
}

export interface HatCollectible {
	position: Position;
	collected: boolean;
	id: number;
}

export interface ConfettiCollectible {
	position: Position;
	collected: boolean;
	id: number;
}

export type Direction = 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';

type LottieSource = object;

export type LetterPartyTheme = {
	key: LETTER_PARTY_THEME_KEYS;
	colors: {
		gameBackground: number;
	};
	images: {
		gameScreen: {
			decorations: {
				sandBottom: string;
				sandcastle: string;
				sandLeft: string;
				sandRight: string;
				swimmingFloat: string;
			};
		};
	};
	animations: {
		startScreen: {
			palmTree: LottieSource;
			speaker: LottieSource;
		};
		gameScreen: {
			palmTree: LottieSource;
			speaker: LottieSource;
			waves: LottieSource;
		};
		endScreen: {
			gull: LottieSource;
			palmTree: {
				default: LottieSource;
				highScore: LottieSource;
			};
		};
	};
};

export enum LETTER_PARTY_THEME_KEYS {
	BEACH = 'beach',
}

export const defaultThemeKey = LETTER_PARTY_THEME_KEYS.BEACH;
